import { brandLogos } from '@liveauctioneers/hammer-ui-core/brandAssets';
import { Link } from '@liveauctioneers/hammer-ui-core/link';
import { ComponentProps } from 'react';

import CheckoutPageHeaderMeta from './CheckoutPageHeaderMeta';

type Props = {
    baseUrl: string;
    catalogId: number;
    houseId: number;
    setZipLoaded: ComponentProps<typeof CheckoutPageHeaderMeta>['setZipLoaded'];
};

export const CheckoutPageHeader = ({ baseUrl, catalogId, setZipLoaded }: Props) => {
    return (
        <section className="mb-lg border-b border-border-secondary">
            <div className="mx-auto my-0 max-w-[1240px] px-lg py-0">
                <CheckoutPageHeaderMeta
                    baseUrl={baseUrl}
                    catalogId={catalogId}
                    setZipLoaded={setZipLoaded}
                />
                <Link href="/">
                    <img
                        alt="LiveAuctioneers"
                        className="my-lg h-[24px]"
                        data-testid="la-logo-asset"
                        src={brandLogos.LiveAuctioneers.brand}
                    />
                </Link>
            </div>
        </section>
    );
};
